// base
export const ROUTE_BASE_ROOT = '/'; // *WARN: DO NOT change this
export const ROUTE_BASE_NAME = '/app'; // *WARN: DO NOT change this
export const ROUTE_WILDCARD = '*';

export const ROUTE_LOGIN = 'login';
export const ROUTE_FORGOT_PASSWORD = 'forgotpassword';
export const ROUTE_HOME = 'home';
export const ROUTE_OAUTH2_LOGIN = 'oauthlogin';
export const ROUTE_OAUTH2_LOGIN_WITH_PARAMS = ROUTE_OAUTH2_LOGIN + '/:email/:token';

// -- USERS
// dashboard
export const ROUTE_DASHBOARD = 'dashboard';

// dashboard
export const ROUTE_EXPERIMENTS = 'experiments';

// Profile
export const ROUTE_PROFILE = 'profile';

// Tenant
export const ROUTE_TENANT = 'tenant';

// Patients
export const ROUTE_PATIENTS = 'patients';
export const ROUTE_UPLOAD_PATIENTS = 'patients/upload';
export const ROUTE_CALLS = 'calls';
export const ROUTE_ANALYTICS = 'analytics';
